<template>
  <footer class="footer">
    <div class="footer__inner">
      <nav class="footer__legal" aria-label="Rechtliches">
        <a href="/impressum">Impressum</a>
        <a href="/datenschutz">Datenschutz</a>
      </nav>

      <div class="footer__meta">
        <nav class="footer__social" aria-label="Kontaktlinks">
          <a class="footer__icon-link" href="/vecura" aria-label="Vecura">
            <ContactChannelIcon class="footer__channel-icon" type="vecura" />
          </a>
          <a
            class="footer__icon-link"
            :href="profile.linkedinUrl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <ContactChannelIcon class="footer__channel-icon" type="linkedin" />
          </a>
          <a class="footer__icon-link" :href="emailHref" aria-label="E-Mail">
            <ContactChannelIcon class="footer__channel-icon" type="mail" />
          </a>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ContactChannelIcon from "@/components/icons/ContactChannelIcon.vue";
import { profile } from "@/data/profile";

const emailHref = computed(() => `mailto:${profile.email}`);
</script>

<style scoped>
.footer {
  margin-right: calc(50% - 50vw);
  margin-left: calc(50% - 50vw);
  border-top: 1px solid rgba(20, 20, 20, 0.06);
  background: var(--page-bg);
  color: var(--header-muted);
  font-size: 0.82rem;
}

.footer__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: min(1180px, calc(100% - 40px));
  margin: 0 auto;
  padding: 18px 0 26px;
}

.footer__social,
.footer__legal,
.footer__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.footer__meta {
  align-items: center;
  justify-content: flex-end;
  gap: 18px;
}

.footer__social a,
.footer__legal a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--header-muted);
  font-weight: 800;
  text-decoration: none;
  transition: color 180ms ease, opacity 180ms ease, transform 180ms ease;
}

.footer__social a:hover,
.footer__legal a:hover {
  color: var(--header-text);
  transform: translateY(-1px);
}

.footer__legal {
  opacity: 0.72;
}

.footer__icon-link {
  width: 20px;
  height: 20px;
  opacity: 0.54;
}

.footer__icon-link:hover {
  opacity: 1;
}

.footer__channel-icon,
.footer__channel-icon :deep(svg) {
  display: block;
  width: 100%;
  height: 100%;
}

@media (max-width: 640px) {
  .footer__inner {
    display: flex;
    width: min(100% - 28px, 1180px);
  }

  .footer__meta {
    justify-content: flex-start;
  }
}

@media (max-width: 760px) {
  .footer {
    display: none;
  }

  .footer__inner {
    display: block;
    width: min(100% - 32px, 1180px);
    padding: 12px 0 14px;
  }

  .footer__meta {
    justify-content: center;
    gap: 0;
  }

  .footer__social {
    display: none;
  }

  .footer__legal {
    justify-content: center;
    gap: 12px;
    font-size: 0.72rem;
    opacity: 0.55;
  }

  .footer__icon-link {
    width: 19px;
    height: 19px;
  }
}
</style>
